import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthProvider';
import { PaywallProvider } from '@/billing/PaywallContext';
import { SectionErrorBoundary } from '@/components/SectionErrorBoundary';
import { LocaleProvider } from '@/i18n/LocaleProvider';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { router } from './router';
import { ToastProvider } from './toasts/ToastProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

/**
 * Дерево провайдеров (снаружи внутрь): ErrorBoundary → Query → Theme → Locale →
 * Auth → Toast → Paywall → Router. Всё, что не зависит от маршрута, живёт выше
 * роутера; телеметрия маршрутов и Clarity — в RootLayout внутри него.
 */
export function App() {
  return (
    <SectionErrorBoundary scope="root">
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LocaleProvider>
            <AuthProvider>
              <ToastProvider>
                <PaywallProvider>
                  <RouterProvider router={router} />
                </PaywallProvider>
              </ToastProvider>
            </AuthProvider>
          </LocaleProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </SectionErrorBoundary>
  );
}
